/* V787 search intent: generic disc/disk synonym and positive-offset brake search.
   Search results only. No SKU exceptions, product changes, or price manipulation. */
(function(){
 'use strict';
 if(!/^\/search\/?$/i.test(location.pathname))return;
 var u;try{u=new URL(location.href);}catch(e){return;}
 var original=u.searchParams.get('q')||'';
 /* Shopify defaults to hiding sold-out search matches. Include them unless
    the buyer explicitly chose a search availability option. */
 var includeAllStock=!!original.trim() && !u.searchParams.has('options[unavailable_products]') &&
   (!u.searchParams.has('type') || u.searchParams.get('type')==='product');
 if(includeAllStock)u.searchParams.set('options[unavailable_products]','show');
 var raw=u.searchParams.get('integy_raw_search')==='1';
 var expanded=original;
 if(!raw && original.length>=3 && original.length<=160 &&
    !/(?:\b(?:tag|product_type):|["']|\b(?:AND|OR)\b)/i.test(original)){
   expanded=original.replace(/\bdisk\b/gi,'disc');
   var offset=/(^|\s)\+\s*(\d{1,3})(?:\s*mm)?(?=\s|$)/i;
   if(offset.test(expanded) && /\b(?:disc|brake)\b/i.test(expanded)){
     if(/\bdisc\b/i.test(expanded) && !/\bbrake\b/i.test(expanded)){
       expanded=expanded.replace(/\bdisc\b/i,'brake disc');
     }
     if(!/\boffset\b/i.test(expanded)){
       expanded=expanded.replace(offset,function(match,space,num){return space+'+'+num+' offset';});
     }
   }
 }
 if(expanded!==original && !raw){
   u.searchParams.set('q',expanded);
   u.searchParams.set('integy_original_q',original);
   u.searchParams.set('integy_intent','1');
   u.searchParams.delete('page');
   location.replace(u.pathname+u.search+u.hash);
   return;
 }
 if(includeAllStock){location.replace(u.pathname+u.search+u.hash);return;}
 var before=u.searchParams.get('integy_original_q')||'';
 if(!before || u.searchParams.get('integy_intent')!=='1' || before===original)return;
 function show(){
   if(document.getElementById('integy-v787-search-intent-note'))return;
   var host=document.querySelector('main#site-main .productgrid--masthead,main#site-main .search--section');
   if(!host)return;
   var note=document.createElement('p');
   note.id='integy-v787-search-intent-note';
   note.setAttribute('role','status');
   note.style.cssText='color:#183b2b;background:#f3f8f5;border:1px solid #bed6c9;border-radius:6px;padding:9px 12px;margin:10px 0;font-size:13px;line-height:1.5';
   note.appendChild(document.createTextNode('Showing focused matches for “'+before+'”. '));
   var originalUrl=new URL(location.href);
   originalUrl.searchParams.set('q',before);
   originalUrl.searchParams.set('integy_raw_search','1');
   originalUrl.searchParams.delete('integy_original_q');
   originalUrl.searchParams.delete('integy_intent');
   originalUrl.searchParams.delete('page');
   var link=document.createElement('a');
   link.href=originalUrl.pathname+originalUrl.search;
   link.textContent='See broader results for your original search';
   link.style.cssText='color:#075e41;font-weight:700;text-decoration:underline;text-underline-offset:2px';
   note.appendChild(link);
   /* Generic search-recall branch: when an offset-brake-disc query was
      tightened for precision, offer a parallel brake-parts search.
      Do not rely on SKU-specific rewrites or merge incomplete result sets. */
   if(/\+\s*\d{1,3}/.test(before) && /\b(?:disc|disk)\b/i.test(before) && !/\bbrake\b/i.test(before)){
     var related=before.replace(/\b(?:disc|disk)\b/gi,'brake');
     if(related!==before){
       var relatedUrl=new URL(originalUrl.href);
       relatedUrl.searchParams.set('q',related);
       var sep=document.createElement('span');
       sep.textContent=' · ';
       var relatedLink=document.createElement('a');
       relatedLink.href=relatedUrl.pathname+relatedUrl.search;
       relatedLink.textContent='Explore related brake parts';
       relatedLink.style.cssText=link.style.cssText;
       note.appendChild(sep);
       note.appendChild(relatedLink);
     }
   }
   host.insertBefore(note,host.firstChild);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',show,{once:true});else show();
})();
